var map = {
	"./anchor.svg": [
		18,
		18
	],
	"./apple.svg": [
		108,
		108
	],
	"./biohazard.svg": [
		130,
		130
	],
	"./bolt.svg": [
		128,
		128
	],
	"./bone.svg": [
		340,
		340
	],
	"./bug.svg": [
		553,
		553
	],
	"./cake.svg": [
		175,
		175
	],
	"./car.svg": [
		278,
		278
	],
	"./cat.svg": [
		859,
		859
	],
	"./clover.svg": [
		605,
		605
	],
	"./flask.svg": [
		207,
		207
	],
	"./futbol.svg": [
		832,
		832
	],
	"./lira.svg": [
		30,
		30
	],
	"./logo.svg": [
		571,
		571
	],
	"./moon.svg": [
		821,
		821
	],
	"./snowflake.svg": [
		863,
		863
	],
	"./spock.svg": [
		555,
		555
	],
	"./sun.svg": [
		724,
		724
	],
	"./wifi.svg": [
		601,
		601
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4;
module.exports = webpackAsyncContext;